export const colorsChartTheme2 = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    cyan: {
        dark: {
            light: "rgba(58, 99, 73, 1)",
            dark: "rgba(86, 125, 100, 1)"
        },
        medium: {
            light: "rgba(82, 130, 79, 1)",
            dark: "rgba(113, 156, 110, 1)"
        },
        light: {
            light: "rgba(142, 165, 125, 1)",
            dark: "rgba(176, 191, 164, 1)"
        },
        darker: {
            light: "rgba(38, 67, 61, 1)",
            dark: "rgba(62, 92, 86, 1)"
        },
        lighter: {
            light: "rgba(169, 182, 148, 1)",
            dark: "rgba(199, 207, 188, 1)"
        },
        disabled: {
            light: "rgba(169, 182, 148, 1)",
            dark: "rgba(199, 207, 188, 1)"
        }
    },
    purple: {
        medium: {
            light: "rgba(128, 94, 143, 1)",
            dark: "rgba(156, 128, 168, 1)"
        },
        darker: {
            light: "rgba(77, 56, 86, 1)",
            dark: "rgba(104, 84, 112, 1)"
        },
        dark: {
            light: "rgba(100, 73, 111, 1)",
            dark: "rgba(128, 105, 138, 1)"
        },
        light: {
            light: "rgba(143, 107, 158, 1)",
            dark: "rgba(172, 143, 184, 1)"
        },
        lighter: {
            light: "rgba(180, 156, 191, 1)",
            dark: "rgba(211, 199, 217, 1)"
        }
    },
    yellow: {
        light: {
            light: "rgba(218, 139, 129, 1)",
            dark: "rgba(242, 176, 167, 1)"
        },
        medium: {
            light: "rgba(212, 120, 108, 1)",
            dark: "rgba(237, 155, 145, 1)"
        },
        dark: {
            light: "rgba(212, 120, 108, 1)",
            dark: "rgba(237, 155, 145, 1)"
        },
        darker: {
            light: "rgba(212, 120, 108, 1)",
            dark: "rgba(237, 155, 145, 1)"
        }
    },
    violet: {
        lighter: {
            light: "rgba(251, 166, 93, 1)",
            dark: "rgba(255, 182, 120, 1)"
        },
        "lighter-weight": {
            light: "rgba(252, 190, 136, 1)",
            dark: "rgba(255, 206, 163, 1)"
        },
        light: {
            light: "rgba(251, 146, 55, 1)",
            dark: "rgba(255, 162, 82, 1)"
        },
        "light-weight": {
            light: "rgba(250, 157, 76, 1)",
            dark: "rgba(255, 173, 102, 1)"
        },

        medium: {
            light: "rgba(240, 115, 5, 1)",
            dark: "rgba(255, 136, 31, 1)"
        },
        dark: {
            light: "rgba(220, 105, 4, 1)",
            dark: "rgba(245, 130, 29, 1)"
        },
        darker: {
            light: "rgba(191, 91, 4, 1)",
            dark: "rgba(217, 115, 26, 1)"
        }
    },
    magenta: {
        medium: {
            light: "rgba(62, 146, 204, 1)",
            dark: "rgba(92, 173, 229, 1)"
        },
        light: {
            light: "rgba(91, 168, 222, 1)",
            dark: "rgba(91, 168, 222, 1)"
        },
        lighter: {
            light: "rgba(109, 181, 232, 1)",
            dark: "rgba(109, 181, 232, 1)"
        }
    },
    gray: {
        medium: {
            light: "rgba(206, 215, 222, 1)",
            dark: "rgba(218, 227, 235, 1)"
        }
    },
    basic: {
        medium: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        },
        dark: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    },
    black: {
        petroleum: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    }
};
